/** Filters for the Zervant quotes list (STR-4). Values are sent as `status` on `/v1/documents/all`. */
export enum QuoteListFilter {
  All = 'all',
  Draft = 'draft',
  Pending = 'pending',
  Accepted = 'accepted',
  Rejected = 'rejected',
  Invoiced = 'invoiced',
}
